import styled from "@emotion/styled";

export const InputContainer = styled.div`
    input {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
`;
